import { axiosWrapper } from "../../axiosWrapper";
export class CountryProfileService {
  public static async getAllCountryProfiles() {
    return await axiosWrapper.Get(
      `CountryProfile/GetCountryProfiles`
    );
  }

  public static async getAllRegions() {
    return await axiosWrapper.Get(
      `CountryProfile/GetRegionProfiles`
    );
  }  

  public static async addNewCountryProfile(countryProfileInfoRecord: {}) {
    return await axiosWrapper.Post('CountryProfile/CountryProfiles', countryProfileInfoRecord);
  }

  public static async updateCountryProfile(countryProfileInfoRecord: {}) {
    return await axiosWrapper.Patch('CountryProfile/CountryProfiles', countryProfileInfoRecord);
  }

  public static async updateActivationStatus(id: string,partitionKey: string, status: string) {
    return await axiosWrapper.Patch(`CountryProfile/UpdateActivationStatus/${id}/${partitionKey}/${status}`);
  }

  public static async getAllCountryProfileActivitylogs(records: number, skip: number) {
    return await axiosWrapper.Get(
      `CountryProfile/CountryProfileActivityLogs/${records}/${skip}`
    );
  }
  
  public static async uploadDocument(id: string, file: FormData){
    return await axiosWrapper.UploadDocument(`CountryProfile/AttachDocumment/?id=${id}`, file);
  } 

  public static async getDocument(id:string){
    return await axiosWrapper.Get(`CountryProfile/GetDocumment?id=${id}`);
  }

  public static async getDocumentBlob(id:string){
    return await axiosWrapper.GetDocumentBlob(`CountryProfile/GetDocumment?id=${id}`);
  }




  public static async getCountryProfileDocument(id: string) {
    return await axiosWrapper.GetDocument(`CountryProfile/GetDocumment?id=${id}`);
  }

  public static async getCountryProfileByCountryName(countryName: string) {
    return await axiosWrapper.Get(
      `CountryProfile/GetCountryProfileByCountryName?countryName=${countryName}`
    );
  }  

  public static async pratcieText(id:string){
    return id;
  }

  public static async getCountriesAllCountriesName(){
    return await axiosWrapper.Get('CountryProfile/GetAllCountriesName');
  }

  public static async getDateFormat(countryName: string) {
    return await axiosWrapper.Get(`CountryProfile/GetDateFormat/${encodeURIComponent(countryName)}`);
  }

}
